<template>
  <div :class="[!pdf ? 'p-6 pt-2' : 'p-0 pt-0'] "
  class="sidebar-scrollable-form"
  >

    <img :src="appLogo || '@/assets/images/logo/web-logo.png'" style="height: 80px; object-fit: contain;" />

    <div class="flex items-center justify-between">
      <div>
        <div>
          <strong>Teacher Name: </strong>
          <p v-if="user">
            {{ user.first_name || null }} {{ user.last_name || null }}
          </p>
        </div>
        <div>
          <!-- <strong>Teacher Role: </strong>
          <p>Piano Expert</p> -->
        </div>
      </div>
      <div>
        <div>
          <!-- <strong>Date Issued: </strong>
          <p v->{{from_date}}</p> -->
        </div>
        <div>
          <strong>Payment Period</strong>
          <p v-if="payout">{{ payout.from_date | dateFormatLocalization }} - {{ payout.to_date | dateFormatLocalization }}</p>
        </div>
      </div>
    </div>
    <vs-divider />

    <vs-row>
      <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12" v-if="schoolAddress">
        <strong>Bill from</strong>
        <p class="my-2">
          <span>{{ schoolAddress.customer_type }}</span>
        </p>
        <p>{{ schoolAddress.email }}</p>
        <p>{{ schoolAddress.phone }}</p>
        <address>{{ schoolAddress.address1 }}</address>
        <address>{{ schoolAddress.address2 }}</address>
        <p>
          {{ schoolAddress.city + ", " }} {{ schoolAddress.state + ", " 
          }} {{ schoolAddress.zip + ", "
          }}{{ schoolAddress.country_details.country_name || null }}
        </p>
      </vs-col>
      <vs-col class="px-4" vs-lg="6" vs-sm="12" vs-xs="12" v-if="user">
        <strong>Bill to</strong>
        <p class="my-2">
          <span>
            {{ user.first_name || null }} {{ user.last_name || null }}
          </span>
        </p>
        <p v-if="user.user_active_email">
          {{ user.user_active_email.email || null }}
        </p>
        <p v-if="user.user_active_phone">
          {{ user.user_active_phone.phone || null }}
        </p>
        <address v-if="user.user_active_address">
          {{ user.user_active_address.address1 || null }}
        </address>
        <address v-if="user.user_active_address">
          {{ user.user_active_address.address2 || null }}
        </address>
        <p>
          <span v-if="user.user_active_address.city !== null">{{ user.user_active_address.city + ", " }}</span>
          <span v-if="user.user_active_address.state !== null">{{ user.user_active_address.state + ", " }}</span>
          <span v-if="user.user_active_address.zip !== null">{{ user.user_active_address.zip + ", "}}</span>
          <span v-if="user.user_active_address.platform_customer_country !== null">{{
            user.user_active_address.platform_customer_country.country_name
          }}</span>
        </p>
        
      </vs-col>
    </vs-row>
    <vs-divider />

    <div class="cstm_vuexy_table">
      <table class="invoice-table">
        <tr>
          <th>Course Name</th>
          <th>Time</th><th>Amount</th>
        </tr>
        <tr v-for="(eachBreakdown, breakIndex) in breakDown.course" :key="breakIndex">
          <td>{{ eachBreakdown.course_name }}</td>

          <td>
            <span>{{ eachBreakdown.formatted_time }}</span>
          </td>
          <td>
            <span><span v-html="currency_code"></span> {{ parseInt(eachBreakdown.hours_spent)*payout.per_hour_payment }}</span>
          </td>
        </tr>

        <tr>
         <!-- <pre> {{breakDown}}</pre> -->
          <td><strong>Total Hours To Pay</strong></td>

          <td>
            <span v-if="payout">{{ payout.total_hour }}<span v-if="payout.total_hour>1"> Hours</span><span v-else> Hour</span></span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td><strong>Hourly Rate</strong></td>
          <td>
            
          </td>
          <td>
            <span v-if="payout"><span v-html="currency_code"></span>{{ payout.per_hour_payment }}</span>
          </td>
        </tr>
        <tr>
          <td><strong>Total Amount Paid</strong></td>
          <td>
            
          </td>
          <td>
            <span v-if="payout"><span v-html="currency_code"></span>{{ payout.total_payment }}</span>
          </td>
        </tr>
      </table>
    </div>
    <vs-divider />

    <div v-if="pdf" class="cstm_vuexy_table mt-4" style="page-break-before: always;">
      <table class="extra_course_table">
        <tbody v-for="i in 2" :key="i.id">
            <tr>
              <th colspan="2">Course Name</th>
              <th colspan="2">Course Type</th>
            </tr>
            <tr>
              <td colspan="2">Networking</td>
              <td colspan="2">Online</td>
            </tr>
            <tr>
              <th>Date</th>
              <th>Time Slots</th>
              <th>Duration</th>
              <th>Hourly Payment</th>
            </tr>
            <tr>
              <td>10.02.2021</td>
              <td>10:00</td>
              <td>2 hours</td>
              <td>100</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td><strong>Subtotal:</strong> $100</td>
            </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3"></td>
            <td><strong>Total:</strong> $200</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="text-right mt-2">
      <vs-button class="mx-1"
        v-if="!pdf"
        @click="downloadPdf()"
      >Download as PDF</vs-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { staffSinglePayoutDetailsApi, getPdfDownload } from '@/api/finance'
export default {
  created () {
    this.staffpayoutDetail()
  },
  props: {
    payid: {},
    pdf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currency_code:JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol,
      payoutDetails: [],
      schoolAddress: null,
      user: null,
      breakDown: [],
      payout: null,
      appLogo: ''
    }
  },
  watch: {
    payid () {
      this.staffpayoutDetail()
    }
  },
  mounted () {
    this.appLogo = JSON.parse(localStorage.getItem('localization')).logo
  },
  methods: {
    async downloadPdf () {
      console.log('hi')
      console.log(this.invoiceSidebarData)
      const payload = {
        id:this.payid
      }
      console.log(payload)
      const {data} = await getPdfDownload(
        localStorage.getItem('customer_id'), payload)
        console.log(data)
      console.log(data.data.url)

      // this.downloadItem(data.data.url, 'label')
      this.downloadItem({'url':data.data.url, 'label':data.data.name})

    
    },

      downloadItem ({ url, label }) {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          console.log(response)
         // debugger
          const blob = new Blob([response.data], {type:'mime'})
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${url.split('.')[url.split('.').length - 1]}`
          console.log(link)
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    
    async staffpayoutDetail () {
      try {
        const payload = {
          id: this.payid
        }
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await staffSinglePayoutDetailsApi(
          customer_id,
          payload
        )
        this.schoolAddress = data.data.school_details
        this.user = data.data.payout.user
        this.breakDown = data.data.breakDown
        this.payout = data.data.payout

        // console.log(data.data.)
      } catch (err) {
        console.warn(err)
      }
    }
  }
}
</script>

<style>
.extra_course_table tbody {
  border: 1px solid #ebe9f1;
  margin-bottom: 5px;
}
.extra_course_table tfoot {
  background: #f3f2f7;
}
</style>